export default __webpack_public_path__ + "static/media/default.86082b96.jpg";